import React from 'react';
import {PageTitle} from '../../common/pageTitle/PageTitle';
import { withRouter } from 'react-router-dom';
import './videoSection.scss';

/**
 * The FactsAndStatsPage component.
 *
 * @constructor
 */
export class VideoSections extends React.Component {
  /**
   * @constructor
   * @param {{}} props
   * @param {{}} componentContext
   */
  constructor(props, componentContext) {
    super(props, componentContext);
  }

  componentDidMount() {
    const { hash } = this.props.location;
    if (hash) {
      const id = hash.replace('#', '');
      console.log(id);
      const node = document.getElementById(id);
      console.log(node);
      if (node) node.scrollIntoView({ behavior: 'smooth' });
    }
  }

  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {

    var videoSections = this.props.videoData;
    console.log('the data coming into the video section component is ',videoSections);
    return (

      <div>


      {videoSections.map((videoSection, index) => (

        <div id={videoSection.title.toLowerCase().replace(/ /g, '-')} key={index} className={'videoSection '  + (index % 2 === 0 ? 'lightSection' : 'darkSection')+ (videoSection.isFeatured===1 ? ' hideFeaturedVideo' :'')}>

          <div className="container">
             <div className="row">
                <div className="col-sm-1 .d-sm-none .d-md-block"></div>
                <div className="videoTitleContainer col-12 col-sm-10">
                  <h2 className="videoSectionTitle">{videoSection.title}</h2>
                </div>
                <div className="col-1 .d-sm-none .d-md-block"></div>
             </div>

             <div className="row">
               <div className="contentContainer col-sm-1 .d-sm-none .d-md-block"></div>

                 <div className="descriptionText contentContainer col-12 col-md-5">
                     {videoSection.description}
                 </div>


               <div className="descriptionVideo contentContainer col-12 col-md-5">
                 <div className="video videoNotFeatured">
                   <iframe src={videoSection.url}  frameBorder="0" webkitallowfullscreen=
                   "true" mozallowfullscreen="true" allowFullScreen="true"></iframe>
                 </div>


                 { videoSection.relatedContentLink && <div className="relatedContent">
                   <h6 className="relatedContentHeadline">RELATED CONTENT</h6>
                   <a href={videoSection.relatedContentLink}>{videoSection.linkName}</a>
                 </div>}

               </div>

               <div className="contentContainer col-sm-1 .d-sm-none .d-md-block"></div>
             </div>
             </div>
           </div>
      ))}

      </div>
    );
  }
}

VideoSections.propTypes = {};

export default withRouter(VideoSections);



// WEBPACK FOOTER //
// ./src/components/common/videoSection/videoSection.js